module.exports = __webpack_public_path__ + "static/media/lys-is-wrong.27ef3b06.mp3";